import { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/padel-landing.css";

export default function PadelLanding() {
  useEffect(() => {
    document.title = "Sport X — Padel";
    return () => { document.title = "Sport X"; };
  }, []);

  return (
    <div className="padel-page" data-testid="padel-landing-page">
      <div className="phone">

        {/* Header */}
        <div className="header">
          <div className="logo">SPORT <span className="x">X</span></div>
          <Link to="/" className="play-now-btn" data-testid="padel-header-play-btn">PLAY NOW</Link>
        </div>

        {/* Hero */}
        <div className="hero">
          <div className="pill">LIVE AUCTIONS · LIVE SPORT · YOUR FRIENDS</div>
          <h1>THE AUCTION<br />STARTS IN<br /><span className="accent">19 SECONDS.</span></h1>
          <div className="hero-sub">
            <strong>Bid on real padel players. Compete with friends. Follow Premier Padel live.</strong>
          </div>
          <div className="hero-tagline">Free to play. No app. No betting.</div>
          <div className="padel-badge">
            <span className="badge-sport">🎾</span>
            <div>
              <strong>Now live for Premier Padel</strong>
              Italy Major · Valencia P1 · Madrid P1 · Barcelona Finals
            </div>
          </div>
        </div>

        {/* Auction widget — Agustín Tapia, Valencia P1 (static demo) */}
        <div className="auction">
          <div className="auction-top">
            <div className="countdown">00:19</div>
            <div className="live-tag">LIVE</div>
          </div>
          <div className="player-name">Agustín Tapia</div>
          <div className="player-meta">🇦🇷 Argentina · Ranked #1 · Premier Padel Valencia P1</div>
          <div className="bid-label">CURRENT HIGHEST BID</div>
          <div className="bid-amount">£15m</div>
          <div className="bid-leader">daz6 leading</div>
          <div className="bid-buttons">
            <div className="bid-btn">+£1m</div>
            <div className="bid-btn">+£5m</div>
            <div className="bid-btn">+£10m</div>
            <div className="bid-btn">+£20m</div>
            <div className="bid-btn">+£50m</div>
            <div className="bid-btn pass">Pass</div>
          </div>
          <div className="participants">
            <div className="avatar">DA</div>
            <div className="avatar go">GO</div>
            <div className="avatar sk">SK</div>
            <div className="avatar ma">MA</div>
            <span>4 of 6 friends · 3 online</span>
          </div>
        </div>

        {/* CTA after widget */}
        <div className="cta-section">
          <Link to="/" className="cta-primary" data-testid="padel-hero-cta">START PLAYING FREE</Link>
          <button
            className="cta-secondary"
            data-testid="padel-how-it-works-btn"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("padel-how");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            HOW IT WORKS
          </button>
          <div className="disclaimer">
            <span className="accent">No real money.</span> No gambling. No app to download. Free to play.
          </div>
        </div>

        {/* Tournament strip — Premier Padel 2026 */}
        <div className="tournament-strip">
          <div className="tournament-pill next">🎾 Italy Major</div>
          <div className="tournament-pill">🎾 Valencia P1</div>
          <div className="tournament-pill">🎾 Málaga P1</div>
          <div className="tournament-pill">🎾 Madrid P1</div>
          <div className="tournament-pill">🎾 Paris Major</div>
          <div className="tournament-pill">🎾 Barcelona Finals</div>
        </div>

        {/* How It Works */}
        <div className="section" id="padel-how">
          <div className="section-label">HOW IT WORKS</div>
          <h2 className="section-title">FOUR STEPS.<br />ONE GREAT NIGHT.</h2>

          <div className="step-card">
            <span className="step-icon">🏛️</span>
            <span className="step-number">1</span>
            <div className="step-title">CREATE A COMPETITION</div>
            <div className="step-body">Pick a Premier Padel tournament. Give your competition a name. Invite your group with one link — no account needed to join.</div>
          </div>

          <div className="step-card">
            <span className="step-icon">⚡</span>
            <span className="step-number">2</span>
            <div className="step-title">LIVE AUCTION</div>
            <div className="step-body">Everyone gets a virtual budget. Bid against each other for real Premier Padel players in a live, real-time auction. Thirty seconds per player. Pure adrenaline.</div>
          </div>

          <div className="step-card">
            <span className="step-icon">📊</span>
            <span className="step-number">3</span>
            <div className="step-title">FOLLOW THE RESULTS</div>
            <div className="step-body">Scores update automatically from real Premier Padel match results. Watch your squad climb the leaderboard — or collapse. No tinkering required.</div>
          </div>

          <div className="step-card">
            <span className="step-icon">🏆</span>
            <span className="step-number">4</span>
            <div className="step-title">WINNER TAKES GLORY</div>
            <div className="step-body">At the end of the tournament, the best squad wins. Bragging rights. Maybe a donation to the winner&apos;s chosen good cause. The conversation that runs for weeks.</div>
          </div>
        </div>

        {/* Why Sport X */}
        <div className="why-section">
          <div className="why-label">WHY SPORT X</div>
          <h2 className="why-title"><span className="red">NO GAMBLING.</span><br /><span className="blue">ALL GAME.</span></h2>

          <div className="benefit">
            <div className="benefit-icon no">🚫</div>
            <div className="benefit-content">
              <div className="benefit-title">No real money</div>
              <div className="benefit-body">Virtual budgets only. The thrill with none of the risk.</div>
            </div>
          </div>

          <div className="benefit">
            <div className="benefit-icon no">🚫</div>
            <div className="benefit-content">
              <div className="benefit-title">No weekly management</div>
              <div className="benefit-body">Bid once. Follow the results. That&apos;s it.</div>
            </div>
          </div>

          <div className="benefit">
            <div className="benefit-icon no">🚫</div>
            <div className="benefit-content">
              <div className="benefit-title">No app to download</div>
              <div className="benefit-body">Works on any phone or laptop, straight from a link.</div>
            </div>
          </div>

          <div className="benefit">
            <div className="benefit-icon yes">✓</div>
            <div className="benefit-content">
              <div className="benefit-title">Real players. Real results.</div>
              <div className="benefit-body">Scores update live from official Premier Padel data.</div>
            </div>
          </div>

          <div className="benefit">
            <div className="benefit-icon yes">✓</div>
            <div className="benefit-content">
              <div className="benefit-title">Private groups</div>
              <div className="benefit-body">Your mates only. No strangers, no public leaderboards.</div>
            </div>
          </div>

          <div className="benefit">
            <div className="benefit-icon yes">✓</div>
            <div className="benefit-content">
              <div className="benefit-title">Play for a cause</div>
              <div className="benefit-body">Contribute to a club or charity if you want to. 90% goes straight there.</div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="final-cta">
          <div className="ready-label">READY?</div>
          <h2 className="final-title">START YOUR<br /><span className="accent">COMPETITION</span><br />TODAY</h2>
          <div className="final-body">Free to set up. Free to play. Takes five minutes to create and share with your group. No excuses.</div>
          <Link to="/" className="final-cta-btn" data-testid="padel-final-cta">PLAY NOW — IT&apos;S FREE</Link>
          <div className="clubs-link">
            Running a club or charity? <Link to="/padel-partner">See how Sport X can raise funds for you →</Link>
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <div className="footer-logo">SPORT <span className="x">X</span></div>
          <div className="footer-text">© 2026 Sport X is a Jana platform. Not a gambling product. No real money involved.</div>
          <div className="footer-links">
            <Link to="/about">About</Link>
            <Link to="/help">Help</Link>
            <Link to="/padel-partner">For clubs</Link>
            <Link to="/padel-partner">For charities</Link>
          </div>
        </div>

        {/* Sticky bottom nav */}
        <div className="sticky-nav">
          <a
            href="#padel-how"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("padel-how");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            HOW IT WORKS
          </a>
          <Link to="/padel-partner">FOR CLUBS</Link>
          <Link to="/" className="play-now-btn" data-testid="padel-stickynav-play">PLAY NOW</Link>
        </div>

      </div>
    </div>
  );
}
